import { FunctionComponent, useCallback, useEffect } from 'react'

import SelectExtratoImpl from 'modules/pagamentos/domain/usecases/SelectExtratoImpl'
import { useFiltro } from 'modules/pagamentos/hooks/useFiltro'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'

import ExtratoItem from './components/ExtratoItem'
import { Container, ContainerText } from './styles'

type TExtratoProps = {
  selectExtrato: SelectExtratoImpl
}

const Extrato: FunctionComponent<TExtratoProps> = () => {
  const {
    extrato,
    loading,
    requestError,
    setRequestError,
    fetchExtrato,
    dateIni,
    dateFim,
  } = useFiltro()
  const handleFetchExtrato = useCallback(async () => {
    await fetchExtrato(dateIni, dateFim)
  }, [dateIni, dateFim, fetchExtrato])

  useEffect(() => {
    handleFetchExtrato()
  }, [])

  return (
    <Container>
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
      {extrato?.detalhes && !!extrato?.detalhes.length ? (
        extrato?.detalhes.map((item, index) => {
          return (
            <ExtratoItem
              key={`${item.protocolo_requisicao}-${item.data}-${index}`}
              item={item}
            />
          )
        })
      ) : (
        <ContainerText>
          <Text>Selecione o período para acessar o extrato</Text>
        </ContainerText>
      )}
      <SnackBar
        open={!!requestError}
        message={requestError}
        setOpen={() => setRequestError('')}
        severity={'error'}
      />
    </Container>
  )
}

export default Extrato
